import { action } from 'easy-peasy';

import type { VizSceneStateModel } from './vizScene';

type VizErrorState = {
  hasVizError: boolean;
  vizErrorMessage: string;
};

export const vizErrorDefaultState: VizErrorState = {
  hasVizError: false,
  vizErrorMessage: '',
};

type VizErrorModelSlice = Pick<
  VizSceneStateModel,
  'setHasVizError' | 'setVizErrorMessage'
>;

export const vizErrorModel: VizErrorModelSlice = {
  setHasVizError: action((state, hasError) => {
    state.hasVizError = hasError;
  }),
  setVizErrorMessage: action((state, errorMessage) => {
    state.vizErrorMessage = errorMessage;
  }),
};
